import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/mascotas",
        label: "Mascotas",
    },
    {
        path: "",
        label: "Visualización",
        isActive: true
    }
]

function MostrarMascota(){
    return (
        <Page title="Visualización de Mascota" description="Información detallada de mascota." breadCrumbs={breadCrumbs}>
            <CardSection />
        </Page>
    );
}

export default MostrarMascota;